
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/reset-password",
      function () {
        return require("private-next-pages/mobiworkx/reset-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/reset-password"])
      });
    }
  